module.exports = __webpack_public_path__ + "static/6 - Boite a rythme Boutons -597832fa1a59580e09e20d4fb15f62c5.mp3";